import * as React from "react";

function SvgFreshpaint(props, ref) {
  return (
    <svg
      id="Freshpaint_svg__Layer_1"
      x={0}
      y={0}
      viewBox="0 0 91.9 125"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {".Freshpaint_svg__st0{fill:#ee5757}.Freshpaint_svg__st1{fill:#61dabf}"}
      </style>
      <g id="Freshpaint_svg__Black">
        <g id="Freshpaint_svg__Freshpaint-LOGO-SVG">
          <g id="Freshpaint_svg__Group">
            <path
              id="Freshpaint_svg__Path"
              className="Freshpaint_svg__st0"
              d="M.2 75.2V48.8c0-1.3 1.1-2.4 2.4-2.4h29.7c1.3 0 2.4 1.1 2.4 2.4v26.3c0 1.3-1.1 2.4-2.4 2.4H2.7c-1.4.1-2.5-1-2.5-2.3z"
            />
            <path
              id="Freshpaint_svg__Path_1_"
              className="Freshpaint_svg__st1"
              d="M34.8 94.4v27c0 1.3-1.1 2.4-2.4 2.4l-29.7.2c-1.3 0-2.4-1.1-2.4-2.4V94.4c0-1.3 1.1-2.4 2.4-2.4h29.7c1.3 0 2.4 1.1 2.4 2.4z"
            />
            <path
              id="Freshpaint_svg__Path_2_"
              className="Freshpaint_svg__st0"
              d="M91.9 2.6c0-1.3-1.1-2.4-2.4-2.4H2.7C1.4.2.3 1.3.3 2.6v27c0 1.3 1.1 2.4 2.4 2.4h86.8c1.3 0 2.4-1.1 2.4-2.4v-27z"
            />
            <path
              id="Freshpaint_svg__Path_3_"
              className="Freshpaint_svg__st1"
              d="M91.9 48.8c0-1.3-1.1-2.4-2.4-2.4H52.6c-1.3 0-2.4 1.1-2.4 2.4v26.3c0 1.3 1.1 2.4 2.4 2.4h36.9c1.3 0 2.4-1.1 2.4-2.4V48.8z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgFreshpaint);
